import React from 'react';
import { connect } from 'react-redux';

import Image from 'components/atoms/Image';
import { RootState } from 'types';
import { translate } from 'utils/translate';
import { withRouter } from 'utils/withRouter';

interface ForbiddenErrorProps {
    forbiddenError: boolean;
}

interface ForbiddenErrorState {
    forbiddenError: boolean;
}

class ForbiddenError extends React.Component<ForbiddenErrorProps, ForbiddenErrorState> {
    constructor(props: ForbiddenErrorProps) {
        super(props);
        this.state = {
            forbiddenError: false,
        };
    }

    static getDerivedStateFromProps(props: ForbiddenErrorProps, state: ForbiddenErrorState) {
        if (props.forbiddenError !== state.forbiddenError) {
            return {
                forbiddenError: props.forbiddenError,
            };
        }
        return null;
    }

    render() {
        return (
            <>
                {this.state.forbiddenError && (
                    <section className="z-100 fixed left-0 top-0 items-center justify-center inset-0 flex fixed-position w-full h-full   bg-white overflow-hidden">
                        <div className="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="relative">
                                <Image src="/static/images/application-error.png" className="mx-auto" alt="error" />
                                <blockquote className="mt-8">
                                    <div className="max-w-3xl mx-auto text-center leading-9 font-sm text-gray-900">
                                        <p className="font-sm font-bold">{translate('Access forbidden')}</p>
                                        <p className="text-sm">
                                            {translate('You dont have the permission to access this page')}
                                        </p>
                                    </div>
                                </blockquote>
                            </div>
                        </div>
                    </section>
                )}
            </>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    forbiddenError: state.errors.forbiddenError,
});

export default connect(mapStateToProps)(withRouter(ForbiddenError));
